import { useEffect, useState } from "react";
import useManager from "../../../../../hooks/useManager";
import INotify from "../../../../../types/INotify";
import Observer from "../../../../../manager/Observer";

export default function useMenu() {
  const [message, setMessage] = useState({} as INotify);
  const manager = useManager();

  useEffect(() => {
    const observer = new Observer();
    manager.get().addObserver(observer);
    observer.callback = (props: INotify) => {
      setMessage(props);
    };
    return () => {
      manager.get().removeObserver(observer);
    };
  }, []);

  async function openSideBar() {
    manager.notify({
      openSideBar: true,
      filterQty: message.filterQty,
    });
  }

  return { message, openSideBar };
}
